import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WecomContactType } from "@packages/chat-sdk";

export interface WecomContactsPersistentStoreType {
  userId?: string;
  roomId?: string;
  contactType?: WecomContactType;
  tabContactType?: WecomContactType;
}
export const wecomContactsPersistentStore =
  new Store<WecomContactsPersistentStoreType>(
    persist(
      () => ({
        userId: undefined,
        roomId: undefined,
        contactType: undefined,
        tabContactType: undefined,
      }),
      {
        name: storageKey.WECOM_CONTACTS_STORAGE, // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    ) as any
  );

export const wecomContactsPersistentStoreActions = {
  selectContactOrRoom(payload: {
    userId?: string;
    roomId?: string;
    contactType?: WecomContactType;
  }) {
    wecomContactsPersistentStore.set(payload);
  },
  selectTabContactType(tabContactType?: WecomContactType) {
    wecomContactsPersistentStore.set({
      tabContactType: tabContactType || WecomContactType.OUTER_SINGLE,
    });
  },
  reset() {
    localStorage.removeItem(storageKey.WECOM_CONTACTS_STORAGE);
  },
};
